import React, {useEffect} from 'react';
import {getLabels, getResults, getConfiguration, setBackground} from "../../../store/slices/productFinder";
import {useDispatch, useSelector} from "react-redux";
import {v4 as uuid} from "uuid";

const ResultPage = (props) => {

    const {
        pageData
    } = props;

    const dispatch = useDispatch();

    const labels = useSelector(getLabels);

    useEffect(() => {
        dispatch(setBackground(pageData?.background || 'dots'));
    }, [pageData]);


    return (
        <div key={`result_${uuid()}`} className="generic-wrapper">
            <div className={`product-finder-page product-finder-page__result product-finder-page__result__${pageData?.results?.length}`}>

                { labels?.resultPageTitle &&
                    <h2
                        className="h4 animate slide-in-bottom animation-delay-3 pb-4"
                        dangerouslySetInnerHTML={{__html: labels.resultPageTitle}}
                    />
                }

                { (pageData.results && pageData.results.length > 0)
                    ?
                        <div className={`product-finder-results-wrapper`}>
                            { pageData.results.map((result, i) => {
                                return (
                                    <Result
                                        key={`result_${i}_${result}`}
                                        resultId={result}
                                    />
                                );
                            }) }
                        </div>
                    :
                        <></>
                }

            </div>
        </div>
    )
}

const Result = (props) => {

    const {
        resultId
    } = props;

    const results = useSelector(getResults);
    const result = results[resultId];

    if(!result) {
        return null;
    }

    return (
        <div className="product-finder-result">

            <img
                className="animate slide-in-bottom animation-delay-6"
                src={ result.img }
                alt={ result.title }
            />

            { result?.title &&
                <h4
                    className="h5 animate slide-in-bottom animation-delay-9">
                    <span dangerouslySetInnerHTML={{
                            __html: result.title
                        }}
                    />
                </h4>
            }

            { result?.description &&
                <p className="animate slide-in-bottom animation-delay-12">
                    <span
                        dangerouslySetInnerHTML={{__html: result.description}}
                    />
                </p>
            }

            { (result?.ctas && result?.ctas.length > 0) &&
                <CtaList
                    ctas={result.ctas}
                />
            }

        </div>
    );

}

const CtaList = (props) => {

    const {
        ctas
    } = props;

    if(!ctas || !Array.isArray(ctas) || !ctas.length) {
        return null
    }

    return (
        <div className="product-finder-result-ctas">
            { ctas.map((_cta, delay) => {
                return (
                    <Cta
                        key={`cta_${uuid()}`}
                        cta={_cta}
                        delay={delay}
                    />
                )
            })}
        </div>
    )
}

const Cta = (props) => {

    const {
        cta,
        delay
    } = props;

    const onClick = (e) => {
        e.preventDefault();
        document.location.href = cta.href
    }

    const delayCoef = 7;

    return (
        <button
            className={`button button--style-1 text-default animate slide-in-bottom animation-delay-${(delay+2) * delayCoef}`}
            onClick={onClick}
        >
            <span className={'button__label'}>
                {cta.label}
            </span>
        </button>
    )
}

export default ResultPage;
